import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { cn } from '@/lib/utils'
import guideContent, { GuideOption, GuideSection } from './content'
import { useMeetingAppContext } from '@/MeetingAppContextDef'
import { debateToolModes } from '@/utils/common'

export const GuidebookModal: React.FC = () => {
  const guideSections: GuideSection[] = guideContent
  const defaultOption: GuideOption = guideSections[0]?.options[0] || {
    key: '',
    content: '',
  }
  const [selectedOption, setSelectedOption] = useState<GuideOption>(defaultOption)

  const { setDebateToolMode, debateToolMode } = useMeetingAppContext()

  const MarkdownParagraph: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => (
    <p className="mb-6" {...props} />
  )

  return (
    <Dialog
      open={debateToolMode === debateToolModes.GUIDEBOOK}
      onOpenChange={(open) => {
        if (!open) setDebateToolMode(null)
      }}
    >
      <DialogContent size="xl" className="max-h-[85vh] w-full h-full p-0 overflow-hidden">
        <div className="flex flex-col md:flex-row w-full h-full dark:text-white">
          {/* Sidebar */}
          <div className="md:w-[30%] w-full md:border-r border-gray-200 p-4 overflow-y-auto noScrollbar max-h-[40vh] md:max-h-none">
            <h2 className="mb-4 text-lg font-bold">Debate Guidebook</h2>
            {guideSections.map((section, sectionIndex) => (
              <div key={section.section} className="mb-4">
                <div className="flex w-full items-center mb-2 text-sm font-semibold uppercase tracking-wide">
                  {section.section}
                </div>
                <ul className="flex flex-col space-y-1 px-2 md:px-0">
                  {section.options.map((option) => {
                    const isSelected = selectedOption.key === option.key

                    return (
                      <li key={option.key}>
                        <Button
                          variant="ghost"
                          onClick={() => setSelectedOption(option)}
                          className={cn(
                            'relative w-full text-left py-2 px-4 rounded transition-colors hover:bg-gray-300 dark:hover:bg-accent',
                            isSelected && 'bg-accent font-semibold',
                          )}
                        >
                          {isSelected && (
                            <>
                              <span className="absolute left-0 top-0 bottom-0 w-1 bg-green-500 rounded-r-md" />
                              <span className="absolute right-0 top-0 bottom-0 w-1 bg-green-500 rounded-l-md" />
                            </>
                          )}
                          {option.key}
                        </Button>
                      </li>
                    )
                  })}
                </ul>
                {sectionIndex < guideSections.length - 1 && (
                  <div className="my-4 border-t border-gray-400" />
                )}
              </div>
            ))}
          </div>

          {/* Content */}
          <div className="flex-1 p-6 overflow-y-auto max-h-[45vh] md:max-h-none  border-t border-black">
            <DialogTitle className="flex flex-col mb-4 text-2xl font-bold">
              {selectedOption.key}
            </DialogTitle>
            <ReactMarkdown components={{ p: MarkdownParagraph }}>
              {selectedOption.content}
            </ReactMarkdown>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
